import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Grid, Hidden } from '@mui/material/';
import PanelHeader from '../components/panelheader/panelHeader';
import PageLayout from '../pagelayout';

import LanguageSwitch from '../i18n/languageSwitch';
import { StudiestedApiContext } from '../api/StudiestedApiContext';
import { useLoader } from '../api/useLoader';
import { useUpdater } from '../api/useUpdater';
import { BrukerinfoDto } from '../api/generated/studiested-generated-api';
import Spinner from '../components/spinner/spinner';
import { FakeLockedInput } from '../components/input';
import translations from './settings.i18n';

const SettingsPage = () => {
  const { formatMessage } = useIntl();
  const { brukerApi } = useContext(StudiestedApiContext);
  const { data: userinfo, loading } = useLoader(
    () => brukerApi.brukerinfoGet(),
    [],
  );
  return (
    <PageLayout
      isIndented={true}
      title={formatMessage({ id: translations.title.id })}
      subtitle={formatMessage({ id: translations.subtitle.id })}
    >
      {loading && <Spinner />}
      {userinfo && (
        <>
          <Userinfo userinfo={userinfo} />
          <AlpSettings />
        </>
      )}
    </PageLayout>
  );
};

const Userinfo: React.FC<
  React.PropsWithChildren<{ userinfo: BrukerinfoDto }>
> = ({ userinfo }) => {
  const { fornavn, etternavn, telefonnummer, epost } = userinfo;
  const { formatMessage } = useIntl();
  return (
    <Grid container={true} spacing={3}>
      <Grid item={true} xs={12}>
        <PanelHeader
          title={formatMessage({ id: translations.userTitle.id })}
          subtitle={formatMessage({ id: translations.userSubtitle.id })}
        />
      </Grid>

      <Grid item={true} sm={6} xs={12}>
        <FakeLockedInput
          label={formatMessage({ id: translations.userName.id })}
          value={fornavn + ' ' + etternavn}
        />
      </Grid>
      <Hidden only={['xs']}>
        <Grid item={true} sm={6} />
      </Hidden>
      <Grid item={true} sm={6} xs={12}>
        <FakeLockedInput
          label={formatMessage({ id: translations.useremail.id })}
          value={epost}
        />
      </Grid>
      <Grid item={true} sm={6} xs={12}>
        <FakeLockedInput
          label={formatMessage({ id: translations.userphone.id })}
          value={telefonnummer}
        />
      </Grid>
    </Grid>
  );
};

const AlpSettings: React.FC<React.PropsWithChildren<{}>> = () => {
  const { brukerApi } = useContext(StudiestedApiContext);
  const { doPost } = useUpdater();

  const postLanguageChanged = (spraakvalg: string) => {
    doPost(
      async () =>
        await brukerApi.brukerinfoInnstillingerPut({
          brukerinnstillingerDto: { spraakvalg },
        }),
    );
  };

  const { formatMessage } = useIntl();
  return (
    <>
      <PanelHeader
        title={formatMessage({ id: translations.portalTitle.id })}
        subtitle={formatMessage({ id: translations.portalSubtitle.id })}
      />

      <Grid container={true}>
        <LanguageSwitch onLanguageChanged={postLanguageChanged} />
      </Grid>
    </>
  );
};

export default SettingsPage;
